module.exports = __webpack_public_path__ + "static/craftconf-73d47d98e39363f954a52d77e46e90f3.png";